// import { useContext } from "react";
// import { SessionContext } from "../common/contexts/SessionContext";

// import styles from "./MultiViewer.module.css";
import { Viewer } from "../ViewerLayout/FullViewer";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { PageError } from "../main/common/PageError/PageError";
import { FullScreenWrapper } from "../common/wrapper/FullScreenWrapper/FullScreenWrapper";
import { useUnpaginate } from "../api/BaseEntityApi";
import { Dataset, DatasetFilters, datasetsConstants } from "../api/Datasets";
import { LoadingWrapper } from "../common/LoadingWrapper";
import { PageInfo } from "../main/common/PageInfo/PageInfo";
import { SessionContext } from "../common/contexts/SessionContext";

export const maxDatasetsInViewer = 32 as const;

export const MultiViewer = () => {
  const [datasetIds, setDatasetIds] = useState<number[]>([]);
  const { session } = useContext(SessionContext);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const urlDatasetIds = query.get("ids");

  useEffect(() => {
    if (urlDatasetIds) {
      const ids = urlDatasetIds
        .split(",")
        .map((id) => parseInt(id.trim(), 10))
        .filter((id) => !isNaN(id));
      setDatasetIds(ids);
    }
  }, [urlDatasetIds]);

  const { data, status, fetchStatus, error } = useUnpaginate<Dataset, DatasetFilters>(
    datasetsConstants.resource,
    {
      ids: datasetIds,
    },
    { enabled: !!datasetIds.length && !!session?.features.enable_mweb }
  );

  const containsMestreNova =
    !!session?.features.enable_mweb &&
    !!(data && Object.values(data)?.some((dataset) => dataset.format?.id === "multi_mestrelab_mnova"));

  if (!datasetIds || (Array.isArray(datasetIds) && !datasetIds.length))
    return <PageError errorMessage="No dataset ids provided" />;

  if (Array.isArray(datasetIds) && datasetIds.length > maxDatasetsInViewer)
    return <PageError errorMessage={`Maximum number of datasets in viewer is ${maxDatasetsInViewer}`} />;

  return (
    <FullScreenWrapper>
      <LoadingWrapper status={status} fetchStatus={fetchStatus} error={error}>
        {containsMestreNova ? (
          <PageInfo message={"Viewer overlay for datasets containing MestReNova files is not supported."} />
        ) : (
          <Viewer ids={datasetIds} />
        )}
      </LoadingWrapper>
    </FullScreenWrapper>
  );
};
